import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import { Form, Grid, Segment } from "semantic-ui-react";
import BotonGuardar from "../botones/BotonGuardar";

function renderTextField({ input, meta: { touched, error }, ...others }) {
  return <Form.Input {...input} {...others} />;
}

function renderTextArea({ input, meta: { touched, error, warning } }) {
  return (
    <div>
      <textarea {...input} placeholder="Descripcion..." rows="10" cols="40" />
      {touched &&
        ((error && <span>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  );
}

class ActividadForm extends React.Component {
  render() {
    const { handleSubmit, pristine, reset, submitSucceeded } = this.props;

    return (
      <Form>
        <Segment>
          <Grid columns="2">
            <Grid.Row>
              <Grid.Column>
                <label>
                  Nombre Actividad
                  <Field
                    required
                    id="nombre"
                    name="nombre"
                    type="text"
                    component={renderTextField}
                  />
                </label>
              </Grid.Column>
              <Grid.Column>
                <label>
                  Importe
                  <Field
                    required
                    id="importe"
                    name="importe"
                    type="text"
                    component={renderTextField}
                  />
                </label>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid columns="1">
            <Grid.Row>
              <Grid.Column>
                <label>
                  Descripción
                  <Field
                    id="descripcion"
                    name="descripcion"
                    type="text"
                    component={renderTextArea}
                  />
                </label>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
        <Segment basic padded="very">
          <BotonGuardar
            disabled={pristine || submitSucceeded}
            floated="right"
            action={handleSubmit(values => this.props.action(values))}
            buttontext="Guardando"
            icon="checkmark"
          />
          <BotonGuardar
            disabled={pristine || submitSucceeded}
            floated="right"
            buttonText="Descartar Cambios"
            icon="cancel"
            action={reset}
          />
        </Segment>
      </Form>
    );
  }
}

ActividadForm.propTypes = {
  action: PropTypes.func.isRequired
};

export default reduxForm({ form: "FormularioActividad" })(ActividadForm);



// WEBPACK FOOTER //
// ./src/pages/shared/actividades/ActividadForm.jsx